const LIFESTYLE_1 = '/shop-lifestyle-1.jpg';

const LIFESTYLE_2 = '/shop-lifestyle-2.jpg';

const LIFESTYLE_3 = '/shop-hero.jpg';

const LIFESTYLE_4 = '/shop-lifestyle-4.jpg';

export default function LifestyleSection() {
  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Image grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto">
          <div className="aspect-[3/4] rounded-lg overflow-hidden bg-[#6B1E3B]">
            <img
              src={LIFESTYLE_1}
              alt="Woman holding card deck on bed with journal open"
              className="w-full h-full object-cover object-top"
              title="H.O.M.E Collection lifestyle"
            />
          </div>
          <div className="aspect-[3/4] rounded-lg overflow-hidden bg-[#6B1E3B]">
            <img
              src={LIFESTYLE_2}
              alt="Woman writing in journal at wooden table with cards"
              className="w-full h-full object-cover object-top"
              title="H.O.M.E Collection lifestyle"
            />
          </div>
          <div className="aspect-[3/4] rounded-lg overflow-hidden bg-[#6B1E3B]">
            <img
              src={LIFESTYLE_3}
              alt="Woman in silk robe by fireplace with journal and cards"
              className="w-full h-full object-cover object-top"
              title="H.O.M.E Collection lifestyle"
            />
          </div>
          <div className="aspect-[3/4] rounded-lg overflow-hidden bg-[#6B1E3B]">
            <img
              src={LIFESTYLE_4}
              alt="Four journal cover variants with card decks"
              className="w-full h-full object-cover object-top"
              title="H.O.M.E Collection journal variants"
            />
          </div>
        </div>
      </div>
    </section>
  );
}